import { getUID } from 'Misc/id';

export default class Provider {
  constructor(container) {
    this.name      = 'genericProvider';
    this.ready     = false;
    this.container = container;
  }

  update(state, prevState, changes) {}
  
  exposeBridge(bridge) {
    const name = `${this.name}${getUID()}`;
    this.containerWin[name] = bridge;
    return name;
  }

  get containerDoc() {
    let doc;

    try {
      doc = this.container.ownerDocument;
    } catch(e) {
      doc = document;
    }

    return doc;
  }

  get containerWin() {
    let win;

    try {
      win = this.containerDoc.defaultView || this.containerDoc.parentWindow;
    } catch(e) {
      win = window;
    }

    return win;
  }
}


// WEBPACK FOOTER //
// ./src/Services/Measurement/ExternalProviders/Provider.js